/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  Get1PathParameters,
  GetAll1Params,
  SimulationDTO,
  SimulationRequest,
  SimulationSummaryDTO,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getSimulation = () => {
  /**
 * Get all simulations (summary), optionally filtered by client

Required authority: PERM_SUPER_ADMIN
 */
  const getAll1 = (params?: GetAll1Params) => {
    return customInstance<SimulationSummaryDTO[]>({
      url: `/api/sms-simulator/simulations`,
      method: "GET",
      params,
    });
  };
  /**
 * Create a simulation

Required authority: PERM_SUPER_ADMIN
 */
  const create1 = (simulationRequest: SimulationRequest) => {
    return customInstance<SimulationDTO>({
      url: `/api/sms-simulator/simulations`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: simulationRequest,
    });
  };
  /**
 * Get simulation by ID

Required authority: PERM_SUPER_ADMIN
 */
  const get1 = ({ id }: Get1PathParameters) => {
    return customInstance<SimulationDTO>({
      url: `/api/sms-simulator/simulations/${id}`,
      method: "GET",
    });
  };
  return { getAll1, create1, get1 };
};
export type GetAll1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSimulation>["getAll1"]>>
>;
export type Create1Result = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getSimulation>["create1"]>>
>;
export type Get1Result = NonNullable<Awaited<ReturnType<ReturnType<typeof getSimulation>["get1"]>>>;
